(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Ad source: first touch of a visit with utm_*, fbclid or Google Ads click ids, kept 30 days in ss:src.
  // sell-flow.js adds it to the trade-in quote so the Desk shows which ad brought each device.
  try {
    const q = new URLSearchParams(location.search);
    const utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map((k) => q.get(k) || '');
    const fbclid = q.get('fbclid') || '';
    const gclid = q.get('gclid') || q.get('gbraid') || q.get('wbraid') || '';
    if (utm.some(Boolean) || fbclid || gclid) {
      const prev = JSON.parse(localStorage.getItem('ss:src') || 'null');
      if (!prev || Date.now() - prev.t > 30 * 864e5) {
        localStorage.setItem('ss:src', JSON.stringify({ t: Date.now(), src: utm[0] || (fbclid ? 'facebook' : gclid ? 'google' : ''), med: utm[1] || (fbclid || gclid ? 'cpc' : ''), cmp: utm[2], ad: utm[3], fbc: fbclid ? `fb.1.${Date.now()}.${fbclid}` : '', gclid, page: location.pathname }));
      }
    }
  } catch (e) { /* storage blocked */ }

  // Holographic foil (.holo seal, .inspect cards): colour bands slide as the page scrolls.
  if (document.querySelector('.holo, .inspect') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const root = document.documentElement;
    let ticking = false;
    const setHolo = () => {
      const p = (scrollY * 0.12) % 200;
      root.style.setProperty('--holo', (p > 100 ? 200 - p : p).toFixed(1));
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(setHolo); } }, { passive: true });
    setHolo();
  }

  // SmartSource loader: same markup as snippets/ss-loader.liquid (styles in base.css, .ss-loader).
  // Default: a phone screen fills pink and the S pops in. 'sm' (inside buttons): a ring spins while the S draws itself.
  const S_PATH = 'M36 8H19a8 8 0 0 0 0 16h10a8 8 0 0 1 0 16H12';
  const loader = (label = 'Loading', size = '') => size === 'sm'
    ? `<span class="ss-loader ss-loader--sm" role="status"><svg class="ss-loader__mark" viewBox="-8 -8 64 64" aria-hidden="true"><circle class="ss-loader__ring" cx="24" cy="24" r="29" pathLength="100"/><path class="ss-loader__track" d="${S_PATH}"/><path class="ss-loader__s" pathLength="100" d="${S_PATH}"/></svg><span class="ss-loader__label">${label}</span></span>`
    : `<span class="ss-loader" role="status"><span class="ss-loader__phone" aria-hidden="true"><i></i><b></b></span><span class="ss-loader__label">${label}</span></span>`;
  window.ssLoader = loader;
  // Cover an element with the loader until its content is replaced (or busy(el, false))
  const busy = (el, on) => {
    el.classList.toggle('is-busy', on);
    const cur = el.querySelector(':scope > .ss-busy');
    if (on && !cur) el.insertAdjacentHTML('beforeend', `<div class="ss-busy">${loader('Updating')}</div>`);
    if (!on) cur?.remove();
  };
  // Button: small spinning S + text while working; returns a restore function
  const btnBusy = (b, text) => { const html = b.innerHTML; b.disabled = true; b.innerHTML = loader(text, 'sm') + text; return () => { b.innerHTML = html; b.disabled = false; }; };

  // Page transitions: only when the next page takes longer than 350 ms, so fast clicks never flash it.
  // Built on first use, never shown on first load, and it doesn't block clicks.
  {
    let pl, wait, safety;
    const hide = () => { clearTimeout(wait); clearTimeout(safety); pl?.classList.remove('is-on'); };
    const show = () => {
      if (!pl) { pl = document.createElement('div'); pl.className = 'ss-page-loader'; pl.innerHTML = loader(); document.body.append(pl); }
      pl.classList.add('is-on'); clearTimeout(safety); safety = setTimeout(hide, 10000);
    };
    const later = e => { clearTimeout(wait); wait = setTimeout(() => { if (!e.defaultPrevented) show(); }, 350); };
    document.addEventListener('click', e => {
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.closest('[data-no-loader]')) return;
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search)) return;
      later(e);
    });
    document.addEventListener('submit', e => {
      const f = e.target, t = e.submitter?.getAttribute('formtarget') || f.target;
      if (f.method === 'dialog' || (t && t !== '_self') || f.closest('[data-no-loader]')) return;
      later(e);
    });
    addEventListener('pageshow', hide);
  }

  // Announcement close
  $$('[data-announcement] [data-close]').forEach(b => b.addEventListener('click', () => b.parentElement.remove()));
  // Rotating announcements: JS takes over from the CSS animation so the arrows can switch messages.
  $$('.announcement--rotate').forEach(bar => {
    const msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    const speed = (Number(bar.dataset.speed) || 10) * 1000;
    let i = 0, timer;
    const show = (n, dir = 1) => {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach((m, k) => { m.classList.toggle('is-active', k === i); m.classList.toggle('is-up', dir < 0); m.toggleAttribute('inert', k !== i); m.removeAttribute('aria-hidden'); });
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), speed); };
    bar.classList.add('is-js');
    show(0); start();
    bar.querySelector('[data-ann-prev]')?.addEventListener('click', () => { show(i - 1, -1); start(); });
    bar.querySelector('[data-ann-next]')?.addEventListener('click', () => { show(i + 1); start(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
  });

  // Mobile menu
  const menuBtn = $('[data-menu-toggle]'), menu = $('[data-menu]');
  // Mobile menu height = space actually left below the menu's top edge (works with iOS toolbars and the announcement bar)
  // On mobile the open menu is fixed from the header's bottom edge to the bottom of the screen, so iOS can't scroll the header away
  const fitMenu = () => { if (!menu?.classList.contains('is-open')) return; const top = Math.max(0, (menu.closest('.header') || menu.parentElement).getBoundingClientRect().bottom); menu.style.setProperty('--menu-top', top + 'px'); menu.style.setProperty('--menu-h', (window.visualViewport ? visualViewport.height : innerHeight) - top + 'px'); };
  const setMenu = open => { menu?.classList.toggle('is-open', open); if (!open) menu?.removeAttribute('data-panel'); menuBtn?.setAttribute('aria-expanded', open); document.documentElement.classList.toggle('menu-lock', !!open); if (open) { menu.scrollTop = 0; fitMenu(); requestAnimationFrame(fitMenu); } };
  addEventListener('resize', fitMenu); addEventListener('scroll', fitMenu, { passive: true }); window.visualViewport?.addEventListener('resize', fitMenu);
  menuBtn?.addEventListener('click', () => setMenu(!menu?.classList.contains('is-open')));
  // Mobile menu drill-in: Shop and Services open their own panel, Back returns to the main list
  $$('[data-mnav-go]', menu || document).forEach(b => b.addEventListener('click', () => { const p = b.dataset.mnavGo; p === 'main' ? menu.removeAttribute('data-panel') : menu.setAttribute('data-panel', p); menu.scrollTop = 0; $('[data-mnav-go]', p === 'main' ? menu : $(`[data-mnav-panel=${p}]`, menu))?.focus(); }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu?.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); } });
  matchMedia('(min-width: 750px)').addEventListener('change', e => e.matches && setMenu(false));

  // Menu images are rendered as data-msrc (sections/header.liquid); load them on the first interaction
  const navImgs = () => { $$('#HeaderMenu img[data-msrc]').forEach(i => { if (i.dataset.msrcset) i.srcset = i.dataset.msrcset; i.src = i.dataset.msrc; i.removeAttribute('data-msrc'); }); };
  ['pointerover', 'pointerdown', 'focusin', 'keydown', 'touchstart'].forEach(ev => document.addEventListener(ev, navImgs, { once: true, passive: true }));
  // Mega menu: hover intent on desktop, tap to expand on mobile
  const overlay = document.createElement('div'); overlay.className = 'mega-overlay'; document.body.append(overlay);
  const desktop = () => matchMedia('(min-width: 750px)').matches;
  const closeAll = () => { $$('[data-nav-item].is-open').forEach(i => { i.classList.remove('is-open'); $('.nav-link', i)?.setAttribute('aria-expanded', 'false'); }); document.body.classList.remove('mega-open'); };
  const openItem = item => { closeAll(); item.classList.add('is-open'); $('.nav-link', item)?.setAttribute('aria-expanded', 'true'); if (desktop()) document.body.classList.add('mega-open'); };
  let t; // shared timer so leaving one item can't close the next one
  $$('[data-nav-item].has-mega').forEach(item => {
    item.addEventListener('mouseenter', () => { if (!desktop()) return; clearTimeout(t); t = setTimeout(() => openItem(item), document.body.classList.contains('mega-open') ? 0 : 120); });
    item.addEventListener('mouseleave', () => { if (!desktop()) return; clearTimeout(t); t = setTimeout(closeAll, 150); });
    $('.nav-link', item).addEventListener('click', e => { if (desktop() || item.hasAttribute('data-mega-desktop')) return; e.preventDefault(); item.classList.contains('is-open') ? closeAll() : openItem(item); });
    $('.nav-link', item).addEventListener('keydown', e => { if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); openItem(item); $('.mega a', item)?.focus(); } });
    item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) closeAll(); });
  });
  document.addEventListener('keydown', e => e.key === 'Escape' && closeAll());

  // Carousels
  $$('[data-carousel]').forEach(root => {
    const track = $('[data-track]', root);
    if (!track) return;
    const step = () => track.clientWidth * 0.8;
    $$('[data-prev]', root).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: -step() })));
    $$('[data-next]', root).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: step() })));
  });

  // Slideshows: scroll-snap track + dots, arrows, autoplay (paused on hover, focus, hidden tab, reduced motion)
  $$('[data-slideshow]').forEach(root => {
    const track = $('[data-slides]', root);
    const slides = track ? [...track.children] : [];
    if (slides.length < 2) return;
    const dots = $$('[data-slide-dot]', root);
    let i = 0, timer;
    const go = n => { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft }); };
    const mark = () => dots.forEach((d, k) => { d.classList.toggle('is-active', k === i); k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'); });
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { i = Math.round(track.scrollLeft / track.clientWidth); mark(); }); }, { passive: true });
    $('[data-slide-prev]', root)?.addEventListener('click', () => { go(i - 1); stop(); });
    $('[data-slide-next]', root)?.addEventListener('click', () => { go(i + 1); stop(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); stop(); }));
    const secs = +root.dataset.autoplay;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let paused = false, stopped = false;
    const start = () => { clearInterval(timer); if (!secs || reduce || stopped) return; timer = setInterval(() => { if (!paused && !document.hidden) go(i + 1); }, secs * 1000); };
    const stop = () => { stopped = true; clearInterval(timer); };
    root.addEventListener('mouseenter', () => (paused = true));
    root.addEventListener('mouseleave', () => (paused = false));
    root.addEventListener('focusin', () => (paused = true));
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) paused = false; });
    track.addEventListener('touchstart', stop, { passive: true });
    start();
  });

  // Collection filters: apply on change, drop empty fields, slide-out drawer on mobile
  $$('[data-filter-form]').forEach(form => {
    const clean = () => $$('input, select', form).forEach(el => { if (!el.value || (el.type === 'checkbox' && !el.checked)) el.disabled = true; });
    form.addEventListener('submit', clean);
    const send = () => { clean(); form.submit(); };
    form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox], [data-autosubmit]')) send(); });
    const drawer = $('[data-filter-drawer]', form), opener = $('[data-filter-open]', form);
    const setOpen = open => { form.classList.toggle('filters-open', open); opener?.setAttribute('aria-expanded', open); document.body.style.overflow = open ? 'hidden' : ''; if (open) $('summary', drawer)?.focus(); };
    opener?.addEventListener('click', () => setOpen(true));
    $$('[data-filter-close]', form).forEach(b => b.addEventListener('click', () => { setOpen(false); opener?.focus(); }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && form.classList.contains('filters-open')) { setOpen(false); opener?.focus(); } });
  });

  // Help center: live search across questions + open whichever chat app is installed
  $$('[data-help]').forEach(root => {
    const input = $('[data-help-search]', root), none = $('[data-help-none]', root);
    const qs = $$('[data-help-q]', root), groups = $$('[data-help-group]', root), topics = $('[data-help-topics]', root);
    input?.addEventListener('input', () => {
      const term = input.value.trim().toLowerCase();
      let hits = 0;
      qs.forEach(q => { const on = !term || q.textContent.toLowerCase().includes(term); q.hidden = !on; if (on) hits++; if (term && on) q.open = false; });
      groups.forEach(g => (g.hidden = term && !$$('[data-help-q]', g).some(q => !q.hidden)));
      if (topics) topics.hidden = !!term;
      if (none) none.hidden = !term || hits > 0;
    });
    const chatBtn = $('[data-help-chat]', root), note = $('[data-help-chat-note]', root);
    chatBtn?.addEventListener('click', () => {
      const inbox = document.querySelector('inbox-online-store-chat');
      const inboxBtn = inbox?.shadowRoot?.querySelector('button');
      if (inboxBtn) return inboxBtn.click();
      if (window.tidioChatApi) return window.tidioChatApi.open();
      if (window.GorgiasChat?.open) return window.GorgiasChat.open();
      if (typeof window.zE === 'function') return window.zE('messenger', 'open');
      if (chatBtn.dataset.fallback) return window.open(chatBtn.dataset.fallback, '_blank', 'noopener');
      if (note) note.hidden = false;
      $('#HelpContactForm')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  // Header search dropdown: popular searches when empty, Shopify predictive search while typing
  $$('[data-search-box]').forEach(form => {
    const input = $('input[name=q]', form), panel = $('[data-search-panel]', form);
    const idle = $('[data-search-idle]', panel), results = $('[data-search-results]', panel);
    if (!input || !panel) return;
    const root = (window.Shopify?.routes?.root || '/');
    const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const money = v => { const n = Number(v); return isNaN(n) ? '' : n.toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'CAD' }); };
    const open = () => input.setAttribute('aria-expanded', 'true');
    const close = () => { input.setAttribute('aria-expanded', 'false'); active = -1; };
    let timer, ctrl, active = -1;
    const items = () => $$('a, button', panel).filter(el => el.offsetParent !== null);
    const render = (q, data) => {
      const r = data?.resources?.results || {};
      const qs = (r.queries || []).slice(0, 4), ps = (r.products || []).slice(0, 5), cs = (r.collections || []).slice(0, 3), pg = (r.pages || []).slice(0, 2);
      let html = '';
      if (qs.length) html += '<p class="search-panel__label">Suggestions</p><ul class="search-panel__list">' + qs.map(x => `<li><a class="search-panel__item" href="${esc(x.url)}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span>${x.styled_text || esc(x.text)}</span></a></li>`).join('') + '</ul>';
      if (ps.length) html += '<p class="search-panel__label">Products</p><ul class="search-panel__list">' + ps.map(p => `<li><a class="search-panel__product" href="${esc(p.url)}"><span class="search-panel__thumb">${p.image ? `<img src="${esc(p.image)}&width=120" alt="" loading="lazy">` : ''}</span><span class="search-panel__ptext"><span>${esc(p.title)}</span><small>${p.price ? 'From ' + money(p.price_min || p.price) : ''}</small></span></a></li>`).join('') + '</ul>';
      const more = [...cs.map(c => ({ t: c.title, u: c.url })), ...pg.map(p => ({ t: p.title, u: p.url }))];
      if (more.length) html += '<p class="search-panel__label">Categories &amp; pages</p><ul class="search-panel__list">' + more.map(m => `<li><a class="search-panel__item" href="${esc(m.u)}"><span>${esc(m.t)}</span></a></li>`).join('') + '</ul>';
      if (!qs.length && !ps.length && !more.length) html += `<p class="search-panel__empty">No matches for “${esc(q)}”.</p>`;
      html += `<a class="search-panel__all" href="${root}search?type=product&q=${encodeURIComponent(q)}">See all results for “${esc(q)}” →</a>`;
      results.innerHTML = html;
    };
    const update = () => {
      const q = input.value.trim();
      clearTimeout(timer); active = -1;
      if (!q) { results.hidden = true; results.innerHTML = ''; idle.hidden = false; return; }
      idle.hidden = true; results.hidden = false;
      if (!results.firstChild) results.innerHTML = loader('Searching');
      timer = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=query,product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: ctrl.signal }); render(q, await res.json());
        } catch (e) { if (e.name !== 'AbortError') render(q, null); }
      }, 180);
    };
    input.addEventListener('focus', () => { open(); update(); });
    input.addEventListener('input', () => { open(); update(); });
    input.addEventListener('keydown', e => {
      const list = items();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
        list.forEach((el, i) => el.classList.toggle('is-active', i === active)); list[active]?.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1 && list[active]) { e.preventDefault(); list[active].click(); }
      else if (e.key === 'Escape') { close(); input.blur(); }
    });
    form.addEventListener('focusout', e => { if (!form.contains(e.relatedTarget)) close(); });
    $('[data-search-chat]', panel)?.addEventListener('click', e => {
      const inboxBtn = document.querySelector('inbox-online-store-chat')?.shadowRoot?.querySelector('button');
      if (inboxBtn) return inboxBtn.click();
      if (window.tidioChatApi) return window.tidioChatApi.open();
      if (window.GorgiasChat?.open) return window.GorgiasChat.open();
      if (typeof window.zE === 'function') return window.zE('messenger', 'open');
      location.href = e.currentTarget.dataset.href;
    });
  });

  // Utility bar: postal code popover (saved on this device) + close popovers on outside click
  $$('[data-postal]').forEach(box => {
    const input = $('[data-postal-input]', box), label = $('[data-postal-label]', box), err = $('[data-postal-err]', box);
    const show = v => { if (v && label) label.textContent = 'Deliver to ' + v; };
    try { show(localStorage.getItem('ss_postal')); } catch (e) {}
    const save = () => {
      const v = (input.value || '').toUpperCase().replace(/\s+/g, '');
      if (!/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/.test(v)) { if (err) err.hidden = false; return; }
      const nice = v.slice(0, 3) + ' ' + v.slice(3);
      if (err) err.hidden = true; try { localStorage.setItem('ss_postal', nice); } catch (e) {} document.dispatchEvent(new Event('ss:postal'));
      show(nice); box.open = false;
    };
    $('[data-postal-save]', box)?.addEventListener('click', save);
    input?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); save(); } });
  });
  document.addEventListener('click', e => $$('.utility-pop[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }));

  // Tabs
  $$('[data-tabs]').forEach(root => {
    $$('[data-tab]', root).forEach(tab => tab.addEventListener('click', () => {
      $$('[data-tab]', root).forEach(t => t.classList.toggle('is-active', t === tab));
      $$('[data-panel]', root).forEach(p => (p.hidden = p.dataset.panel !== tab.dataset.tab));
    }));
  });

  // Video reels: click to play/pause
  $$('[data-reel]').forEach(reel => {
    const v = $('video', reel);
    if (!v) return;
    reel.addEventListener('click', () => {
      if (v.paused) { v.muted = false; v.play(); reel.classList.add('is-playing'); }
      else { v.pause(); reel.classList.remove('is-playing'); }
    });
  });

  // Product page
  // en-CA/fr-CA so CAD shows as "$569.99", not "CA$569.99"
  const fmt = cents => (cents / 100).toLocaleString((document.documentElement.lang || 'en').slice(0, 2) + '-CA', { style: 'currency', currency: window.Shopify?.currency?.active || 'CAD' });
  const SWATCH = { black:'#1b1b1f', midnight:'#1f2430', 'space black':'#2b2b2e', 'space gray':'#6e6e73', graphite:'#54524f', white:'#f5f5f2', starlight:'#f2ece0', silver:'#e3e4e5', gold:'#f2d9b3', red:'#d1001f', '(product)red':'#d1001f', blue:'#8fb3d9', 'pacific blue':'#2f4f6b', 'sierra blue':'#9bb5ce', 'deep blue':'#24344d', 'mist blue':'#a9bfd4', 'sky blue':'#bcd7ec', ultramarine:'#5a6ff0', teal:'#9fd4cf', green:'#c8dcc4', 'alpine green':'#566453', 'midnight green':'#4e5851', yellow:'#f9e479', purple:'#d9cbe8', 'deep purple':'#594f63', pink:'#f7c9cf', coral:'#ee7762', lavender:'#d8c8ef', sage:'#b7c4a6', 'cosmic orange':'#e8743b', 'desert titanium':'#bfa48f', 'natural titanium':'#bab4aa', 'white titanium':'#f2f1ed', 'black titanium':'#3a3a3c', 'blue titanium':'#3f4a5a', 'cloud white':'#f2f2f0', 'light gold':'#ead8b9',
    // Samsung
    'phantom black':'#2a2a2c', 'phantom gray':'#77797d', 'phantom white':'#f1f0ec', 'phantom silver':'#c9cbce', 'phantom violet':'#b7a6d1', 'phantom pink':'#f3cfd0', 'pink gold':'#eac9b5', burgundy:'#6b2737', cream:'#eee5d3', olive:'#8f9a6a', mint:'#c6ead9', onyx:'#2a2a2c', 'onyx black':'#2a2a2c', 'marble gray':'#c7c6c3', 'cobalt violet':'#6c5fa8', 'amber yellow':'#f2d98a', 'titanium black':'#3c3c3e', 'titanium gray':'#8e8d8a', 'titanium violet':'#8a7fa0', 'titanium yellow':'#e9dcae', navy:'#283147', icyblue:'#cfe0ee', 'icy blue':'#cfe0ee', 'silver shadow':'#b8bcc2', 'titanium silverblue':'#a9b8c9', 'titanium whitesilver':'#e7e7e5', 'titanium silver':'#cfd0d2', 'titanium jetblack':'#1e1f22', 'titanium icyblue':'#c5d6e6', jetblack:'#1e1f22', 'jet black':'#1e1f22', 'blue shadow':'#4a5a77', coralred:'#e5604f', 'blue black':'#22304a', 'light blue':'#b9d4ea', 'light gray':'#d6d6d6', 'light green':'#cfe7c8', 'awesome navy':'#2b3550', 'awesome iceblue':'#c9dcec', 'awesome lilac':'#cdb9e3', 'awesome black':'#26262a', 'awesome lavender':'#c8bde6', 'awesome white':'#f4f4f2', 'awesome violet':'#b6a3d6', beige:'#e3d7c4', 'moonstone gray':'#7d7f86', 'platinum silver':'#d9dadc',
    // Apple extras
    'rose gold':'#e8c4b8', 'natural titanium':'#bab4aa', 'black titanium':'#3a3a3c',
    // consoles
    'jet black':'#1e1f22', 'carbon black':'#232323', 'robot white':'#f4f4f4', 'galaxy black':'#1b1d2b', 'neon red/blue':'linear-gradient(90deg,#ff4554 50%,#00c3e3 50%)', turquoise:'#4fd1c5', coral:'#f47c7c' };
  const SW_KEYS = [['obsidian','#2b2c30'],['porcelain','#efe9e1'],['hazel','#8c9a83'],['rose','#f2c9c4'],['peony','#f4b7c8'],['wintergreen','#bfe3cf'],['aloe','#bfe6d0'],['bay','#7fb2d9'],['mint','#bfe9d6'],['sage','#a9b8a0'],['lemongrass','#e6e58e'],['coral','#f08c7a'],['lavender','#c9b8ec'],['lilac','#cdb4e6'],['purple','#8c6cc8'],['violet','#8f6bd1'],['iris','#7b7fd4'],['indigo','#3d4a8c'],['navy','#24324f'],['teal','#2f8f8f'],['ultramarine','#5b6fe0'],['sky','#a9cdee'],['denim','#4c6c9a'],['blue','#5f8fd0'],['green','#6fae7e'],['olive','#7d7f4e'],['yellow','#f5dd73'],['orange','#f19a4a'],['pink','#f2b8c6'],['red','#d1001f'],['cream','#f3ead6'],['beige','#e8dcc4'],['titanium','#b8b3ab'],['desert','#c9a98a'],['bronze','#a8774b'],['copper','#b8734a'],['gold','#e8c98e'],['silver','#dcdde0'],['gray','#7c7d82'],['grey','#7c7d82'],['graphite','#54524f'],['charcoal','#3a3b3f'],['black','#1b1b1f'],['white','#f5f5f2'],['starlight','#f2ece0'],['midnight','#1f2430'],['jet','#151517'],['phantom','#2a2a2e'],['onyx','#232327'],['cobalt','#3456a8']];
  window.applySwatches = (root) => (root || document).querySelectorAll('[data-swatch]').forEach(d => { const k = d.dataset.swatch.toLowerCase(); let c = SWATCH[k]; if (!c) { const hit = SW_KEYS.find(([w]) => k.includes(w)); c = hit ? hit[1] : (CSS.supports('color', k.split(' ').pop()) ? k.split(' ').pop() : '#c9cad1'); } d.style.setProperty('--sw', c); });
  window.applySwatches();

  $$('[data-product]').forEach(root => {
    const main = $('[data-main-img]', root);
    const thumbs = $$('[data-thumb]', root);
    const galMain = main?.closest('.gallery__main');
    // Customer review photos in the gallery (Back Market style): built from this product's own review cards
    // already on the page (only reviews whose "See item" link is this product and that have a photo), max 2, newest first.
    const rvThumbs = [];
    const here = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
    const firstThumb = $('.gallery__thumbs .gallery__thumb', root);
    if (galMain && firstThumb && !root.classList.contains('pdp--acc')) {
      const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const ago = d => { const days = Math.floor((Date.now() - new Date(`${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}`)) / 864e5); if (days < 1) return 'Today'; if (days < 14) return `${days} day${days > 1 ? 's' : ''} ago`; if (days < 60) return `${Math.floor(days / 7)} weeks ago`; if (days < 365) return `${Math.floor(days / 30)} months ago`; const y = Math.floor(days / 365); return `${y} year${y > 1 ? 's' : ''} ago`; };
      const seen = new Set();
      $$('.rv-item[data-rid]').filter(a => {
        const link = $('.rv-prod__link', a); const img = $('.rv-item__photos img', a);
        if (!link || !img || seen.has(a.dataset.rid) || +a.dataset.rating < 4) return false;
        seen.add(a.dataset.rid);
        return new URL(link.href, location.href).pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '') === here;
      }).sort((a, b) => b.dataset.date - a.dataset.date).slice(0, 2).reverse().forEach(a => {
        const src = $('.rv-item__photos img', a).getAttribute('src');
        const big = src.replace(/([?&])width=\d+/, '$1width=1000');
        const nameEl = $('.rv-item__name', a); const name = (nameEl?.firstChild?.textContent || '').trim();
        const rating = +a.dataset.rating; const stars = [1, 2, 3, 4, 5].map(i => `<span${i > rating ? ' class="is-off"' : ''}>★</span>`).join('');
        const tick = $('.rv-badge', a) ? ' <svg viewBox="0 0 16 16" width="14" height="14" aria-label="Verified purchase"><circle cx="8" cy="8" r="8" fill="#fff"/><path d="M4.6 8.2l2.2 2.2 4.4-4.6" fill="none" stroke="#111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '';
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'gallery__thumb gallery__thumb--rv'; b.setAttribute('aria-label', `Customer photo from ${name}`);
        b.innerHTML = `<img src="${esc(src)}" alt="Customer photo" loading="lazy"><template><div class="gal-rv"><div class="gal-rv__img"><img src="${esc(big)}" alt="Customer photo"></div><span class="gal-rv__ago">${ago(a.dataset.date)}</span><div class="gal-rv__foot"><p class="gal-rv__top"><span class="gal-rv__stars" aria-label="${rating} out of 5">${stars}</span> ${rating}/5<span class="gal-rv__name">${esc(name)}${tick}</span></p><p class="gal-rv__body">${esc(($('.rv-item__body', a)?.textContent || '').trim())}</p><a href="#reviews" class="gal-rv__link" data-rv-goto="${esc(a.dataset.rid)}">View full review</a></div></div></template>`;
        // never show an empty slide: drop the thumb if its photo fails
        $('img', b).addEventListener('error', () => b.remove());
        firstThumb.after(b); rvThumbs.push(b);
      });
    }
    const hideRv = () => { galMain?.querySelector('.gal-rv')?.remove(); rvThumbs.forEach(t => t.classList.remove('is-active')); };
    const show = (src, mediaId) => { hideRv(); if (main && (!mediaId || main.dataset.mediaId != mediaId)) { main.src = src; main.removeAttribute('srcset'); if (mediaId) main.dataset.mediaId = mediaId; } thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.mediaId == mediaId)); };
    thumbs.forEach(t => t.addEventListener('click', () => show(t.dataset.thumb, t.dataset.mediaId)));
    rvThumbs.forEach(t => t.addEventListener('click', () => {
      hideRv(); thumbs.forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
      galMain.append($('template', t).content.cloneNode(true));
    }));
    galMain?.addEventListener('click', e => {
      const a = e.target.closest('[data-rv-goto]'); if (!a) return;
      e.preventDefault();
      const el = document.querySelector(`[data-rid="${a.dataset.rvGoto}"]`) || document.querySelector('[data-reviews]');
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.classList.add('is-flash'); setTimeout(() => el.classList.remove('is-flash'), 1800); }
    });
    const tin = $('[data-tradein]', root);
    tin && $('input', tin).addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); location.href = tin.dataset.tradein + '?q=' + encodeURIComponent(e.target.value); } });

    const json = $('[data-product-json]', root);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const cfg = JSON.parse($('[data-pdp-config]', root)?.textContent || '{}');
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root);
    const sets = $$('fieldset[data-option-index]', root);
    const selected = () => sets.map(f => $('input:checked', f)?.value);
    // no option pickers (single-variant items): use the variant the form already holds
    const find = opts => sets.length ? product.variants.find(v => v.options.every((o, i) => o === opts[i])) : product.variants.find(v => String(v.id) === idInput?.value) || product.variants[0];

    const priceHTML = (v, el) => {
      // compare-at = manufacturer's Canadian retail price new; savings rounded down to whole dollars so we never overstate
      // device pages: "new" price comes only from the sourced Canadian MSRP metafield (keyed by option value), never compare-at
      const ref = 'msrp' in cfg ? (cfg.msrp ? Math.round((v.options.map(o => cfg.msrp[o]).find(Boolean) || cfg.msrp['*'] || 0) * 100) : 0) : v.compare_at_price;
      const off = Math.floor((ref - v.price) / 100) * 100;
      const save = off > 0 ? `<span class="pp__was" title="Manufacturer's price new in Canada"><s>${fmt(ref)} ${cfg.compareLabel || 'new'}</s> <span class="pp__save">Save ${fmt(off).replace(/[.,]00(?=\D*$)/, '')}</span></span>` : '';
      let add = 0, n = 0; $$('[data-setup-addon]:checked').forEach(c => { add += +c.dataset.price || 0; n++; });
      const inc = n ? `<span class="pp__inc">incl. ${fmt(add)} for ${n} add-on${n > 1 ? 's' : ''}</span>` : '';
      const tin = el && el.dataset.tradeinLink ? ` <a class="pp__tradein" href="${el.dataset.tradeinLink}">before trade-in</a>` : '';
      return `<div class="pp"><span class="pp__row"><span class="pp__now">${fmt(v.price + add)}</span>${tin}</span>${save}${inc}</div>`;
    };

    const update = (fromUser) => {
      const sel = selected();
      const variant = find(sel);
      // per-choice prices: same selection with this one value swapped
      sets.forEach(f => {
        const idx = +f.dataset.optionIndex;
        const rows = $$('.choice', f).map(label => {
          const inp = $('input', label);
          const alt = sel.slice(); alt[idx] = inp.value;
          const v = find(alt);
          return { label, v };
        });
        const prices = rows.filter(r => r.v && r.v.available).map(r => r.v.price);
        const min = Math.min(...prices);
        rows.forEach(({ label, v }) => {
          const el = $('[data-choice-price]', label);
          const sold = !v || !v.available;
          label.classList.toggle('is-soldout', sold);
          el.textContent = sold ? 'Sold out' : fmt(v.price);
          el.classList.toggle('is-best', !sold && v.price === min && prices.length > 1 && idx === cfg.cond);
        });
      });
      const condNote = $('[data-cond-note]', root);
      const capt = $('[data-cond-caption]', root);
      if (cfg.cond >= 0 && capt) capt.textContent = `Example of ${sel[cfg.cond]} (body, screen)`;
      if (cfg.cond >= 0) { const imgs = $$('[data-cond-img]', root); const vw = ($('[data-cond-view]', root) || { dataset: {} }).dataset.condView || '0'; if (imgs.some(im => im.dataset.condImg === sel[cfg.cond])) imgs.forEach(im => (im.hidden = im.dataset.condImg !== sel[cfg.cond] || (im.dataset.view || '0') !== vw)); $$('[data-cond-chips]', root).forEach(c => (c.hidden = c.dataset.condChips !== sel[cfg.cond])); }

      // Subtitle: options joined by " · ", with a colour dot before the colour only when the name is in SWATCH (no guessing)
      $$('[data-opts-text]', root).forEach(el => {
        el.textContent = '';
        sel.forEach((s, i) => {
          if (i) el.append(' · ');
          const hex = i === cfg.color ? SWATCH[(s || '').toLowerCase()] : null;
          if (hex) { const d = document.createElement('span'); d.className = 'buy__dot'; d.setAttribute('aria-hidden', 'true'); d.style.background = hex; el.append(d); }
          el.append(s || '');
        });
      });
      $$('[data-opt-tags]', root).forEach(el => (el.innerHTML = sel.map(s => `<span>${s}</span>`).join('')));
      $$('[data-sum-tags]', root).forEach(el => {
        const t = sel.slice();
        el.innerHTML = t.map(s => `<span>${s}</span>`).join('');
      });
      if (cfg.color >= 0) $$('[data-color-dot]', root).forEach(d => { const k = (sel[cfg.color] || '').toLowerCase(); d.style.background = SWATCH[k] || k.split(' ').pop(); d.title = sel[cfg.color] || ''; });
      $$('[data-spec-opt]', root).forEach(d => { const v = sel[+d.dataset.specOpt]; if (v) d.textContent = v; });
      const btns = [addBtn, ...$$('[data-add-proxy]', root)];
      if (!variant) { btns.forEach(b => { b.disabled = true; b.textContent = 'Unavailable'; }); $$('[data-price-block]', root).forEach(el => (el.innerHTML = '')); return; }
      idInput.value = variant.id;
      $$('form input[name="id"]').forEach(i => { if (i.closest('#pdp-installments, #pdp-installments-2')) { i.value = variant.id; i.dispatchEvent(new Event('change', { bubbles: true })); } });
      btns.forEach(b => { b.disabled = !variant.available; b.textContent = variant.available ? 'Add to cart' : 'Sold out'; });
      $$('[data-price-block]', root).forEach(el => (el.innerHTML = priceHTML(variant, el)));
      if (variant.featured_media) {
        const src = variant.featured_media.preview_image?.src || variant.featured_image?.src;
        if (src) { const url = /[?&]width=/.test(src) ? src : src + (src.includes('?') ? '&' : '?') + 'width=1200'; show(url, variant.featured_media.id); $$('[data-color-img], [data-variant-thumb]', root).forEach(i => { i.src = url; i.removeAttribute('srcset'); }); }
      }
      if (fromUser) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    };
    document.addEventListener('change', e => { if (e.target.matches('[data-setup-addon]')) update(false); });
    root.addEventListener('change', e => { if (e.target.closest('fieldset[data-option-index]')) update(true); });
    $$('[data-add-proxy]', root).forEach(b => b.addEventListener('click', () => form.requestSubmit()));
    // Good is the default condition unless the link names a variant: keep the other options if that combo is in stock, else take any in-stock Good variant
    const condSet = cfg.cond >= 0 && sets.find(f => +f.dataset.optionIndex === cfg.cond);
    if (condSet && !new URL(location.href).searchParams.get('variant')) {
      const good = $$('input', condSet).find(i => i.value.trim().toLowerCase() === 'good');
      if (good && !good.checked) {
        const alt = selected(); alt[cfg.cond] = good.value;
        const v = find(alt)?.available ? find(alt) : product.variants.find(x => x.available && x.options[cfg.cond] === good.value);
        if (v) sets.forEach(f => { const i = $$('input', f).find(x => x.value === v.options[+f.dataset.optionIndex]); if (i) i.checked = true; });
      }
    }
    update(false);

    // sticky bar + scroll progress
    const sticky = $('[data-sticky]', root), bar = $('[data-progress]', root), anchor = $('.buy__ctas', root);
    if (sticky && anchor) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(anchor);
      addEventListener('scroll', () => { const r = root.getBoundingClientRect(); const p = Math.min(1, Math.max(0, -r.top / (r.height - innerHeight))); bar.style.width = (p * 100) + '%'; }, { passive: true });
    }
  });

  // SmartCare+ plans carry a hidden _covers property (the phone's variant id). Keep each plan's qty at or
  // below its phone's qty, so removing a phone removes its plan. Returns true when the cart was changed.
  window.ssFixPlans = async cart => {
    cart = cart || await (await fetch('/cart.js')).json();
    const qty = {}, updates = {};
    cart.items.forEach(i => { if (!(i.properties || {})._covers) qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
    const phone = {};
    cart.items.forEach(i => { if (i.product_type === 'Smartphone') phone[i.variant_id] = 1; });
    // Only smartphones can carry a plan; a plan left on anything else (or on a removed phone) comes out.
    cart.items.forEach(i => { const c = (i.properties || {})._covers; if (!c) return; const max = phone[c] ? (qty[c] || 0) : 0; if (i.quantity > max) updates[i.key] = max; });
    if (!Object.keys(updates).length) return false;
    await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    return true;
  };

  // Cart drawer (AJAX)
  const drawer = $('[data-drawer]');
  const refreshCart = async () => {
    const boxes = $$('[data-drawer-body], [data-cart-page]');
    boxes.forEach(el => busy(el, true));
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer-items`);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = html.querySelector('.shopify-section')?.innerHTML || '';
      boxes.forEach(el => (el.innerHTML = inner));
    } finally { boxes.forEach(el => busy(el, false)); }
    const cart = await (await fetch('/cart.js')).json();
    $$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
  };
  // Clean up plan lines once per page load when the cart has items, then redraw the drawer if anything changed.
  if ($$('[data-cart-count]').some(c => +c.textContent > 0)) window.ssFixPlans().then(c => { if (c) refreshCart(); }).catch(() => {});
  const openDrawer = () => { if (drawer) { drawer.hidden = false; document.body.style.overflow = 'hidden'; } };
  window.ssRefreshCart = refreshCart; window.ssOpenDrawer = openDrawer;
  const closeDrawer = () => { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } };
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => e.key === 'Escape' && closeDrawer());
  $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { if (drawer) { e.preventDefault(); openDrawer(); } }));

  $$('[data-product-form]').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = $('[data-add]', form), done = btnBusy(btn, 'Adding…');
    const fd = new FormData(form);
    const addons = $$('[data-setup-addon]:checked').map(c => c.matches('[data-scp]')
      ? { id: +c.value, quantity: +(fd.get('quantity') || 1), properties: { _covers: String(fd.get('id')) } }
      : { id: +c.value, quantity: 1 });
    const res = addons.length
      ? await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }].concat(addons) }) })
      : await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
    done();
    if (!res.ok) { alert((await res.json()).description || 'Could not add to cart'); return; }
    await refreshCart();
    const ti = document.getElementById('sd-tradein');
    let hasTi = false, tiRec = null; try { tiRec = JSON.parse(sessionStorage.getItem('ss-tradein') || 'null'); hasTi = !!tiRec; } catch (e) {}
    if (tiRec) {
      const money = n => '$' + Math.round(n).toLocaleString('en-CA');
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: {
        'Trade-in device': tiRec.n + (tiRec.st ? ' ' + tiRec.st : ''),
        'Trade-in condition': [tiRec.c, tiRec.f === true ? 'works' : tiRec.f === false ? 'not working' : tiRec.f, tiRec.s, tiRec.b].filter(Boolean).join(' / ') + (tiRec.sl ? ' / sealed' : ''),
        'Trade-in estimate': tiRec.v ? money(tiRec.v) : 'Quote needed' } }) }).catch(() => {});
    }
    if (hasTi && window.ssOpenAdded && window.ssOpenAdded()) { /* trade-in already chosen on the page: go straight to add-ons */ }
    else if (ti && typeof ti.showModal === 'function') { ti.dataset.fromCart = '1'; ti.showModal(); } else { openDrawer(); }
  }));
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled) return;
    const done = btnBusy(b, 'Adding…');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.quickAdd, quantity: 1 }] }) });
      if (!res.ok) { alert((await res.json()).description || 'Could not add to cart'); return; }
      await refreshCart(); openDrawer();
    } finally { done(); }
  });
  document.addEventListener('click', e => {
    const s = e.target.closest('[data-tradein-skip]');
    if (!s) return;
    const d = s.closest('dialog'); d.classList.add('is-closing');
    setTimeout(() => { d.classList.remove('is-closing'); d.close(); if (!(window.ssOpenAdded && window.ssOpenAdded())) { if (drawer) openDrawer(); else location.href = '/cart'; } }, 260);
  });

  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    b.disabled = true;
    $$('[data-drawer-body], [data-cart-page]').forEach(el => busy(el, true));
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.qty, quantity: +b.dataset.val }) });
    await window.ssFixPlans().catch(() => {});
    refreshCart();
  });
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-scp-add]');
    if (!b) return;
    const done = btnBusy(b, 'Adding…');
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.scpAdd, quantity: +b.dataset.qtyN || 1, properties: { _covers: b.dataset.covers } }] }) });
    if (!r.ok) { done(); return; }
    refreshCart();
  });

  // PDP summary: mini gallery, delivery window, postal code
  $$('[data-sum-gal]').forEach(g => {
    const slides = $$('[data-sum-slide]', g), thumbs = $$('[data-sum-thumb]', g); let i = 0;
    const go = n => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); };
    thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.sumThumb)));
    $('[data-sum-prev]', g)?.addEventListener('click', () => go(i - 1));
    $('[data-sum-next]', g)?.addEventListener('click', () => go(i + 1));
  });
  const addBiz = n => { const d = new Date(); let a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) a++; } return d; };
  const md = d => d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  const sumDel = $('[data-sum-delivery]');
  if (sumDel) {
    const a = addBiz(3), b = addBiz(10);
    sumDel.textContent = `Delivered by ${md(a)} – ${a.getMonth() === b.getMonth() ? b.getDate() : md(b)}`;
    const ex = $('[data-sum-express]'); if (ex) ex.textContent = `Free shipping across Canada`;
  }
  const postalLabel = () => { let p = ''; try { p = localStorage.getItem('ss_postal') || ''; } catch (e) {} $$('[data-sum-postal-label]').forEach(l => (l.textContent = p ? `Deliver to ${p}` : 'Update postal code')); };
  postalLabel(); window.addEventListener('storage', postalLabel); document.addEventListener('ss:postal', postalLabel);
  $$('[data-sum-postal]').forEach(b => b.addEventListener('click', () => {
    const d = $('.utility-postal'); if (!d) return;
    window.scrollTo({ top: 0, behavior: 'smooth' }); d.open = true; setTimeout(() => $('input', d)?.focus(), 350);
  }));
})();
/* Nav: fade the category row's right edge when it overflows (Back Market-style) */
(function(){var nav=document.querySelector('.header__nav'),ul=nav&&nav.querySelector('ul.nav-scroll');if(!ul)return;
var fl=document.createElement('span');fl.className='nav-fade-l';fl.setAttribute('aria-hidden','true');ul.parentNode.insertBefore(fl,ul);
function chk(){nav.classList.toggle('is-overflow',ul.scrollWidth-ul.clientWidth-ul.scrollLeft>4);nav.classList.toggle('is-overflow-l',ul.scrollLeft>4)}
chk();ul.addEventListener('scroll',chk,{passive:true});window.addEventListener('resize',chk);window.addEventListener('load',chk);if(document.fonts)document.fonts.ready.then(chk)})();


// Put the second Shop Pay Installments banner next to Add to cart (rendered outside the product form, moved here)
(function(){var src=document.getElementById('pdp-installments-2'),slot=document.querySelector('[data-inst-mirror]');if(src&&slot){slot.replaceWith(src);src.classList.add('is-placed');}})();

/* Favorites: heart buttons save to this browser (Account > Favorites reads the same list) */
(function(){
  var KEY='ss:favs';
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}}
  function write(l){try{localStorage.setItem(KEY,JSON.stringify(l))}catch(e){}}
  function sync(b){var on=read().some(function(f){return f.h===b.dataset.wishH});b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?'Remove from favorites':'Save to favorites')}
  document.querySelectorAll('[data-wish]').forEach(function(b){
    if(!b.dataset.wishH)return;sync(b);
    b.addEventListener('click',function(){var l=read(),h=b.dataset.wishH,i=l.findIndex(function(f){return f.h===h});
      if(i>-1)l.splice(i,1);else l.unshift({h:h,t:b.dataset.wishT,u:b.dataset.wishU,i:b.dataset.wishI,p:b.dataset.wishP});
      write(l.slice(0,60));sync(b)});
  });
})();

/* Product card hearts (same ss:favs list; delegated so grids loaded later work too) */
(function(){
  var KEY='ss:favs';
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}}
  function sync(){var l=read();document.querySelectorAll('[data-card-wish]').forEach(function(b){var on=l.some(function(f){return f.h===b.dataset.wishH});b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',(on?'Remove ':'Save ')+(b.dataset.wishT||'item')+(on?' from favorites':' to favorites'))})}
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-card-wish]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var l=read(),h=b.dataset.wishH,i=l.findIndex(function(f){return f.h===h});
    if(i>-1)l.splice(i,1);else l.unshift({h:h,t:b.dataset.wishT,u:b.dataset.wishU,i:b.dataset.wishI,p:b.dataset.wishP});
    try{localStorage.setItem(KEY,JSON.stringify(l.slice(0,60)))}catch(x){}
    sync();
  });
  sync();window.addEventListener('storage',sync);window.addEventListener('pageshow',sync);
  if(window.MutationObserver){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(sync,150)}).observe(document.body,{childList:true,subtree:true})}
})();

/* Header account dropdown */
(function(){
  var root=document.querySelector('[data-acct]');if(!root)return;
  var btn=root.querySelector('[data-acct-btn]'),menu=root.querySelector('[data-acct-menu]');
  function set(open){if(open&&window.innerWidth<750)menu.style.top=Math.round(btn.getBoundingClientRect().bottom+8)+'px';else menu.style.top='';menu.hidden=!open;btn.setAttribute('aria-expanded',open?'true':'false');root.classList.toggle('is-open',open)}
  btn.addEventListener('click',function(e){e.stopPropagation();set(menu.hidden)});
  document.addEventListener('click',function(e){if(!root.contains(e.target))set(false)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!menu.hidden){set(false);btn.focus()}});
  menu.addEventListener('click',function(e){if(e.target.closest('a'))set(false)});
})();

// Condition step: flip the example between body and screen
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-cond-flip]');
  if (!btn) return;
  const media = btn.closest('.step__media');
  const box = media && media.querySelector('[data-cond-view]');
  if (!box) return;
  const imgs = [...box.querySelectorAll('[data-cond-img]')];
  const cur = imgs.find(im => !im.hidden);
  if (!cur) return;
  const vw = box.dataset.condView === '1' ? '0' : '1';
  box.dataset.condView = vw;
  imgs.forEach(im => (im.hidden = im.dataset.condImg !== cur.dataset.condImg || im.dataset.view !== vw));
  const lab = box.querySelector('[data-cond-lab]');
  if (lab) lab.textContent = vw === '1' ? 'Screen' : 'Body';
  media.querySelectorAll('.cg__dots i').forEach((d, i) => d.classList.toggle('is-on', String(i) === vw));
});
